// extracted by mini-css-extract-plugin
module.exports = {"--color-primary":"#147fc1","--color-primary-darker":"#1a5071","--color-text":"#222222","--font-family-base":"\"proxima-nova\", \"Helvetica Neue\", Helvetica, Arial, sans-serif"};